export default {
  // Brand
  brand: '#FA422E',
  // Mesh
  meshLightPink: '#FFDBDE',
  meshPink: '#FF85A7',
  meshOrange: '#FFB87A',
  meshSkyBlue: '#1FDDFF',
  meshPurple: '#6B66FF',
  meshRed: '#FF0000',
  // Neutral
  neutralBlack: '#000000',
  neutralWhite: '#FFFFFF',
  neutralGray100: '#FAFAFA',
  neutralGray200: '#DCDCDC',
  neutralGray300: '#8E8E8E',
  neutralGray400: '#393939',
};
